import React, { Component } from 'react';
import { openTip, closeTip, getData_menuExterior } from '../utils';
import FondosInversionTemp from './fondosInversionTemp';
import FondosInversion from './fondosInversion';


class FondosInver extends Component {

    state = {
        configLumina: false, 
        cargandoInfo: true,
    }


    componentDidMount() {
        this.getDateMenuExterior();
    }

    getDateMenuExterior = async () => {
        openTip();
        try {
            const dataMenuE = await getData_menuExterior();
            const configLumina = dataMenuE
                && dataMenuE.configLumina.activo ? true : false;
            this.setState({ configLumina, cargandoInfo: false });

        } catch (error) {
            console.log("Cierra tip fondosInversion en getDateMenuExterior");
      
            this.setState({ cargandoInfo: false });
                  closeTip();
        }
    }

    render() {

        if(this.state.cargandoInfo){
            return <></>;
        }

        if (this.state.configLumina) {
            return (<FondosInversionTemp />)
        } else {
            return (<FondosInversion />)
        }
    }


}

export default FondosInver;